import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/global.scss";
import * as errorMonitoring from "@/utils/error-monitoring";
import { ServiceProvider } from "@/contexts/ServiceProvider";
import { getService } from "@/utils/get-service";
import { TurnstileProvider } from "@/contexts/TurnstileProvider";

errorMonitoring.init();

const service = getService();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ServiceProvider service={service}>
      <TurnstileProvider>
        <App />
      </TurnstileProvider>
    </ServiceProvider>
  </React.StrictMode>,
);
